(function () {
  if (!document.body.classList.contains('template-blog')) return;

  var root = document.querySelector('[data-lux-blog]');
  if (!root) return;

  var cards = root.querySelectorAll('[data-lux-blog-card]');
  var activeFilter = 'all';

  function applyFilter(filter) {
    activeFilter = filter;
    cards.forEach(function (card) {
      if (filter === 'all') {
        card.classList.remove('is-hidden');
        return;
      }
      var tags = (card.getAttribute('data-tags') || '').split('|');
      var match = tags.some(function (t) {
        return t.indexOf(filter) !== -1 || t.replace(/\s+/g, '-') === filter;
      });
      card.classList.toggle('is-hidden', !match);
    });
  }

  root.querySelectorAll('[data-lux-blog-filter]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      root.querySelectorAll('[data-lux-blog-filter]').forEach(function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');
      applyFilter(btn.getAttribute('data-lux-blog-filter'));
    });
  });

  var sortWrap = root.querySelector('[data-lux-blog-sort]');
  if (sortWrap) {
    var grid = root.querySelector('[data-lux-blog-grid]');
    sortWrap.querySelectorAll('[data-sort]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        sortWrap.querySelectorAll('[data-sort]').forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');
        if (!grid) return;
        var items = Array.prototype.slice.call(grid.querySelectorAll('[data-lux-blog-card]'));
        var sort = btn.getAttribute('data-sort');
        items.sort(function (a, b) {
          if (sort === 'popular') {
            return (b.getAttribute('data-published') || 0) - (a.getAttribute('data-published') || 0);
          }
          return (b.getAttribute('data-published') || 0) - (a.getAttribute('data-published') || 0);
        });
        items.forEach(function (el) { grid.appendChild(el); });
      });
    });
  }
})();
